import { Component } from '@angular/core';

@Component({
	selector: 'app-blank-topbar',
	templateUrl: './blank-topbar.component.html',
	styleUrl: './blank-topbar.component.css'
})
export class BlankTopbarComponent {
	logourl = "../../../assets/img/cube_logo.jpeg";
	year: number = new Date().getFullYear();
}
